<template>
  <div>
    <span style="cursor: pointer" class="mx-5" @click="openWhatsApp">
      <v-icon :color="estadoColor">mdi-whatsapp</v-icon>
    </span>
    <v-dialog v-model="handleDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline d-flex justify-space-between align-center">
          <span>Vincular WhatsApp</span>
          <div class="d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  :color="socketConectado ? 'success' : 'error'"
                  small
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ socketConectado ? 'mdi-wifi' : 'mdi-wifi-off' }}
                </v-icon>
              </template>
              <span>{{ socketConectado ? 'Conexión en tiempo real activa' : 'Sin conexión en tiempo real' }}</span>
            </v-tooltip>
            <v-btn icon @click="handleDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" v-if="loader" class="d-flex justify-center">
              <v-progress-circular
                :size="70"
                :width="7"
                color="success"
                indeterminate
              ></v-progress-circular>
            </v-col>
            <v-col cols="12" v-if="estadoActual === 'offline'" class="text-center">
              <v-alert type="warning" dense>
                WhatsApp está en modo offline debido a problemas de conectividad.
              </v-alert>
            </v-col>
            <v-col cols="12" v-if="estadoActual === 'conectado'" class="text-center">
              <v-alert type="success" dense>
                ¡WhatsApp conectado correctamente!
              </v-alert>
            </v-col>
            <v-col cols="12" v-if="estadoActual === 'qr_generado'" class="text-center">
              <p class="subtitle-1 mb-2">Escanea este código con tu WhatsApp</p>
              <div class="qr-container">
                <v-img v-if="imageBase64" :src="imageBase64" max-height="250" contain></v-img>
                <p v-else class="text-caption">Generando código QR...</p>
              </div>
            </v-col>
            <v-col cols="12" v-if="estadoActual === 'error_inicializacion'" class="text-center">
              <v-alert type="error" dense>
                Error al inicializar WhatsApp. Intenta reiniciar la sesión.
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center pb-4">
          <v-btn color="primary" @click="reiniciarSesion" :loading="reiniciando">
            Reiniciar sesión
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import socket from "../../composables/conexionSocket";

export default {
  name: "WhatsAppVincular",

  data() {
    return {
      loader: false,
      handleDialog: false,
      imageBase64: "",
      estadoActual: "",
      intervaloActualizacion: null,
      reiniciando: false,
      socketConectado: false, // Estado de la conexión Socket.IO
    };
  },
  computed: {
    estadoColor() {
      switch(this.estadoActual) {
        case 'conectado':
          return 'green';
        case 'qr_generado':
          return 'orange';
        case 'offline':
          return 'grey';
        case 'error_inicializacion':
          return 'red';
        default:
          return 'grey';
      }
    }
  },
  created() {
    // Configurar escucha de eventos de Socket.IO para actualizaciones de estado WhatsApp
    socket.on('whatsapp_estado_actualizado', (data) => {
      // Actualizar estado y QR
      this.estadoActual = data.estado;
      if (data.qrCode) {
        this.imageBase64 = data.qrCode;
      }
      
      // Si estamos en estado de carga, desactivarla
      if (this.loader) {
        this.loader = false;
      }
      
      // Mostrar notificación cuando se conecta correctamente
      if (data.estado === 'conectado') {
        // Forzar actualización de la UI
        this.$forceUpdate();
      }
    });
    
    // Remover y volver a agregar el listener para evitar duplicados
    socket.off('whatsapp_estado_actualizado').on('whatsapp_estado_actualizado', (data) => {
      // console.log('Evento de actualización de WhatsApp recibido (listener secundario):', data);
      this.estadoActual = data.estado;
      if (data.qrCode) {
        this.imageBase64 = data.qrCode;
      }
      this.$forceUpdate();
    });
    
    // Monitorear estado de conexión de Socket.IO
    socket.on('connect', () => {
      this.socketConectado = true;
      
      // Al conectar, solicitar el estado actual de WhatsApp
      this.requestCode();
    });
    
    socket.on('disconnect', () => {
      this.socketConectado = false;
    });
    
    socket.on('connect_error', (error) => {
      // console.error('Error de conexión socket:', error);
      this.socketConectado = false;
    });
  },
  
  beforeDestroy() {
    // Limpiar intervalo al destruir componente
    if (this.intervaloActualizacion) {
      clearInterval(this.intervaloActualizacion);
    }
    
    // Eliminar escucha de eventos de Socket.IO
    socket.off('whatsapp_estado_actualizado');
  },
  methods: {
    openWhatsApp() {
      this.handleDialog = true;
      this.requestCode();
      
      // Ya no necesitamos polling porque usamos Socket.IO para actualizaciones en tiempo real
      // Eliminamos el intervalo si existe
      if (this.intervaloActualizacion) {
        clearInterval(this.intervaloActualizacion);
        this.intervaloActualizacion = null;
      }
    },
    async requestCode() {
      try {
        this.loader = true;
        let r = await axios.get(
          process.env.VUE_APP_BASE_URL + "sorteos/whatsapp/estado"
        );
        // Actualizar estado y QR
        this.estadoActual = r.data.estado;
        if (r.data.qrCode) {
          this.imageBase64 = r.data.qrCode;
        }
        
        return r.data;
      } catch (e) {
        console.error("Error al obtener estado de WhatsApp:", e);
        this.estadoActual = "error_inicializacion";
      } finally {
        this.loader = false;
      }
    },
    
    async reiniciarSesion() {
      try {
        this.reiniciando = true;
        await axios.post(
          process.env.VUE_APP_BASE_URL + "sorteos/whatsapp/reiniciar"
        );

        // Esperar un momento y luego solicitar el nuevo código QR
        setTimeout(() => {
          this.requestCode();
          this.reiniciando = false;
        }, 5000);
      } catch (e) {
        console.error("Error al reiniciar sesión de WhatsApp:", e);
        this.reiniciando = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
